// export const BASE_URL = 'http://192.168.1.116:7014/api'; //local
// export const IMAGE_BASE_URL = 'http://192.168.1.116:7014';

// export const BASE_URL = 'https://localhost:7014/api'; //local
// export const IMAGE_BASE_URL = 'https://localhost:7014';

// export const BASE_URL = 'http://154.61.77.58:5000/api'; 
// export const IMAGE_BASE_URL = 'http://154.61.77.58:5000';

export const BASE_URL = 'https://partyapi.theskyline.life/api'; //live 
export const IMAGE_BASE_URL = 'https://partyapi.theskyline.life';

export const getImageUrl = (url) => {
    if (!url) return null;
    if (typeof url !== 'string') return url;
    if (url.startsWith('http') || url.startsWith('https')) return url;
    if (url.startsWith('data:')) return url;
    if (url.startsWith('file:')) return url;

    // Remove leading slash from path to avoid double slashes when joining
    const cleanPath = url.startsWith('/') ? url.substring(1) : url;

    // Clean base URL to ensure no trailing slash (though usually const doesn't have it)
    const cleanBase = IMAGE_BASE_URL.endsWith('/') ? IMAGE_BASE_URL.slice(0, -1) : IMAGE_BASE_URL;

    // Use encodeURI to handle spaces and special chars in the path
    // We encode the path but we need to ensure we don't double encode if it's already encoded
    // A simple approach is to replace spaces with %20 which is the most common issue
    return `${cleanBase}/${cleanPath.replace(/ /g, '%20')}`;
};

async function request(endpoint, options = {}) {
    const { method = 'GET', headers = {}, body } = options;

    const isFormData = body instanceof FormData;
    const token = localStorage.getItem('token');

    const headersConfig = {
        ...headers,
    };

    if (token) {
        headersConfig['Authorization'] = `Bearer ${token}`;
    }

    if (!isFormData && (method !== 'GET' && method !== 'DELETE' && body)) {
        headersConfig['Content-Type'] = 'application/json';
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 60000);

    const config = {
        method,
        headers: headersConfig,
        body: isFormData ? body : (body ? JSON.stringify(body) : undefined),
        signal: controller.signal,
    };

    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, config);
        clearTimeout(timeoutId);

        if (!response.ok) {
            const errorText = await response.text();
            let errorMessage = `API Error: ${response.status}`;

            try {
                const errorBody = JSON.parse(errorText);
                errorMessage = errorBody.message || errorBody.error || JSON.stringify(errorBody);
            } catch (e) {
                if (errorText) errorMessage = errorText;
            }

            // Handle 404 for GET requests gracefully
            if (response.status === 404 && method === 'GET') {
                return {
                    success: false,
                    message: errorMessage,
                    data: null,
                    isNotFound: true
                };
            }

            throw new Error(errorMessage);
        }

        const text = await response.text();
        if (!text) {
            return { success: true, data: {} };
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            console.error(`Failed to parse API response: ${method} ${endpoint}`, e);
            return { success: true, message: text };
        }

    } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
            const timeoutError = new Error('Request timed out after 60 seconds');
            console.error(`API Timeout: ${method} ${endpoint}`);
            throw timeoutError;
        }

        const isNotFoundError = error.message?.toLowerCase().includes('not found');
        if (method === 'GET' && isNotFoundError) {
            // Silently handle "not found" for GET requests
        } else {
            console.error(`API Request Failed: ${method} ${endpoint}`, error);
        }
        throw error;
    }
}

export const api = {
    get: (endpoint, headers) =>
        request(endpoint, { method: 'GET', headers }),

    post: (endpoint, body, headers) =>
        request(endpoint, { method: 'POST', body, headers }),

    put: (endpoint, body, headers) =>
        request(endpoint, { method: 'PUT', body, headers }),

    patch: (endpoint, body, headers) =>
        request(endpoint, { method: 'PATCH', body, headers }),

    delete: (endpoint, headers) =>
        request(endpoint, { method: 'DELETE', headers }),
};

export const calendarService = {
    getAll: () => api.get('/calendars'),
    create: (formData) => api.post('/calendars', formData),
    delete: (month, year) => api.delete(`/calendars/${month}/${year}`),
};

